import { User } from '@/api/apiDocs/user'
import { Common } from '@/api/apiDocs/common'
import { Merchant } from '@/api/apiDocs/merchant'
import { SecuritySetting } from '@/api/apiDocs/securitySetting'
import { Easypay } from '@/api/apiDocs/easypay'
import { Transaction } from '@/api/apiDocs/transaction'
import { Wallet } from '@/api/apiDocs/wallet'
import { Purchase } from '@/api/apiDocs/purchase'
import { Receiving } from '@/api/apiDocs/receiving'
import { Behalf } from '@/api/apiDocs/behalf'
import { BankRecord } from '@/api/apiDocs/bankRecord'
import { Fee } from '@/api/apiDocs/fee'
import { OverseasC } from '@/api/apiDocs/overseasCollection'
import { Virtual } from '@/api/apiDocs/virtual'
import { Agent } from '@/api/apiDocs/agent'
import { FileExport} from "@/api/apiDocs/fileExport"
import { OverseasReceipt} from "@/api/apiDocs/overseasReceipt";
export const UserService = new User()
export const CommonService = new Common()
export const MerchantService = new Merchant()
export const SecuritySettingService = new SecuritySetting()
export const EasypayService = new Easypay()
export const TransactionService = new Transaction()
export const WalletService = new Wallet()
export const PurchaseService = new Purchase()
export const ReceivingService = new Receiving()
export const BehalfService = new Behalf()
export const BankRecordService = new BankRecord()
export const FeeService = new Fee()
export const OverseasCService = new OverseasC()
export const VirtualService = new Virtual()
export const AgentService = new Agent()
export const FileDownService = new FileExport()
export const OverseasReceiptService = new OverseasReceipt()
